import {
  Stack,
  Grid,
  Typography,
  Avatar,
  amber,
  deepOrange,
  pink,
  cyan,
} from "fashion/fabrics";
import {
  PaletteIcon,
  SchoolIcon,
  StorefrontIcon,
  PersonIcon,
} from "fashion/icons";

const CodexUserTargetGrid = () => (
  <Grid container rowSpacing={4} columnSpacing={2} my={2}>
    <Grid size={{ xs: 6, sm: 3 }}>
      <Stack gap={1} alignItems="center">
        <Avatar sx={{ bgcolor: amber[700] }}>
          <PersonIcon />
        </Avatar>
        <Typography variant="h5" textAlign="center">
          Individual
        </Typography>
        <Typography color="text.secondary" variant="body2" textAlign="center">
          Organize access to online resources and create personalized dashboard
          for your favorite websites or online tools.
        </Typography>
      </Stack>
    </Grid>
    <Grid size={{ xs: 6, sm: 3 }}>
      <Stack gap={1} alignItems="center">
        <Avatar sx={{ bgcolor: deepOrange[600] }}>
          <StorefrontIcon />
        </Avatar>
        <Typography variant="h5" textAlign="center">
          Business
        </Typography>
        <Typography color="text.secondary" variant="body2" textAlign="center">
          Create simple online resource guides for your members or clients, and
          easy to use pages for information distribution.
        </Typography>
      </Stack>
    </Grid>
    <Grid size={{ xs: 6, sm: 3 }}>
      <Stack gap={1} alignItems="center">
        <Avatar sx={{ bgcolor: pink[800] }}>
          <SchoolIcon />
        </Avatar>
        <Typography variant="h5" textAlign="center">
          Educator
        </Typography>
        <Typography color="text.secondary" variant="body2" textAlign="center">
          Create interactive learning resources for your community and simple
          online training modules.
        </Typography>
      </Stack>
    </Grid>
    <Grid size={{ xs: 6, sm: 3 }}>
      <Stack gap={1} alignItems="center">
        <Avatar sx={{ bgcolor: cyan[500] }}>
          <PaletteIcon />
        </Avatar>
        <Typography variant="h5" textAlign="center">
          Creator
        </Typography>
        <Typography color="text.secondary" variant="body2" textAlign="center">
          Create curated lists of resources for your audience and landing pages
          for your affiliate links or products.
        </Typography>
      </Stack>
    </Grid>
  </Grid>
);

export default CodexUserTargetGrid;
